// JSX version of the "What Time Is It?" clock-matching game
import React, { useState, useRef, useEffect } from 'react';

const WhatTimeIsItGame = () => {
  const [score, setScore] = useState(0);
  const [lives, setLives] = useState(3);
  const [targetHour, setTargetHour] = useState(3);
  const [targetMinute, setTargetMinute] = useState(30);
  const [hourAngle, setHourAngle] = useState(90);
  const [minuteAngle, setMinuteAngle] = useState(180);
  const [result, setResult] = useState('');
  const [gameOver, setGameOver] = useState(false);

  const correctSound = useRef(new Audio("https://cdn.pixabay.com/download/audio/2022/03/15/audio_e1c8b7ed6e.mp3"));
  const wrongSound = useRef(new Audio("https://cdn.pixabay.com/download/audio/2022/03/16/audio_0d139d2629.mp3"));

  const rotateHour = (deg) => {
    setHourAngle((prev) => (prev + deg + 360) % 360);
  };

  const rotateMinute = (deg) => {
    setMinuteAngle((prev) => (prev + deg + 360) % 360);
  };

  const getHourFromAngle = (angle) => {
    return Math.round((angle % 360) / 30) % 12;
  };

  const getMinuteFromAngle = (angle) => {
    return Math.round((angle % 360) / 6) % 60;
  };

  const checkTime = () => {
    if (lives <= 0) return;

    const hour = getHourFromAngle(hourAngle);
    const minute = getMinuteFromAngle(minuteAngle);
    const isCorrect = hour === targetHour && minute === targetMinute;

    if (isCorrect) {
      correctSound.current.play();
      setResult('✅ Correct! New time loaded.');
      setScore((prev) => prev + 1);
      loadNewTime();
    } else {
      wrongSound.current.play();
      setResult(`❌ Incorrect! You set ${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`);
      setLives((prev) => {
        const newLives = prev - 1;
        if (newLives <= 0) {
          setGameOver(true);
        }
        return newLives;
      });
    }
  };

  const loadNewTime = () => {
    const newHour = Math.floor(Math.random() * 12);
    const newMinute = Math.floor(Math.random() * 12) * 5;
    setTargetHour(newHour);
    setTargetMinute(newMinute);
    setHourAngle(0);
    setMinuteAngle(0);
    setResult('');
  };

  const startGame = () => {
    setScore(0);
    setLives(3);
    setGameOver(false);
    loadNewTime();
  };

  useEffect(() => {
    loadNewTime();
  }, []);

  return (
    <div style={{ fontFamily: 'Comic Sans MS', textAlign: 'center', background: 'linear-gradient(to bottom, #e0f7fa, #ffffff)', padding: '20px' }}>
      <h1 style={{ color: '#007acc' }}>🕒 What Time Is It? Game</h1>

      <div style={{ fontSize: '20px', marginBottom: '10px' }}>
        Score: {score} | Lives: <span style={{ color: 'red', fontSize: '24px' }}>{'❤️'.repeat(lives)}</span>
      </div>

      <div style={{ fontSize: '24px', color: '#007acc', margin: '15px' }}>
        Match this time: {String(targetHour).padStart(2, '0')}:{String(targetMinute).padStart(2, '0')}
      </div>

      <div style={{ position: 'relative', width: '300px', height: '300px', border: '10px solid #007acc', borderRadius: '50%', background: '#fff', margin: '20px auto' }}>
        <div style={{ position: 'absolute', bottom: '50%', left: '50%', width: '8px', height: '70px', background: '#007acc', transformOrigin: 'bottom center', transform: `rotate(${hourAngle}deg)`, zIndex: 2 }}></div>
        <div style={{ position: 'absolute', bottom: '50%', left: '50%', width: '4px', height: '100px', background: '#007acc', transformOrigin: 'bottom center', transform: `rotate(${minuteAngle}deg)`, zIndex: 1 }}></div>
      </div>

      <div>
        <button onClick={() => rotateHour(-30)}>Hour ⟲</button>
        <button onClick={() => rotateHour(30)}>Hour ⟳</button>
        <button onClick={() => rotateMinute(-6)}>Minute ⟲</button>
        <button onClick={() => rotateMinute(6)}>Minute ⟳</button>
      </div>

      <div>
        <button onClick={checkTime}>✅ Submit</button>
        <button onClick={startGame}>🔄 Start Game</button>
      </div>

      <div style={{ marginTop: '15px', fontSize: '20px', fontWeight: 'bold', color: gameOver ? 'red' : 'black' }}>{result}</div>
      {gameOver && <div style={{ fontSize: '24px', color: 'red', marginTop: '20px' }}>💀 Game Over! Refresh or click "Start Game" to try again.</div>}
    </div>
  );
};

export default WhatTimeIsItGame;
